import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/home/runner/work/onenews/onenews/web-services/onenews/layouts/custom.vue").then(m => m.default || m))
}